import React from 'react'

import {GetFile} from '../../modules'

export const ServerFilesPage = () => {
  return <GetFile />
}
